export default __webpack_public_path__ + "static/img-point-second-44a0c2cc25ad5f7c9f72d26d1c5c9192.png";